import { Layout } from "antd";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { AppInitializer } from "@/app/AppInitializer";
import { ModalsContainer } from "@/app/ModalsContainer";
import { ROUTES } from "@/constants";
import { UpdateBanner } from "@/features/UpdateBanner";
import {
    useConfigMercure,
    useIndexedDBFocus,
    useLazyWarmups,
    useLoadDictionaries,
    useMercure,
    useOpenReplay,
    usePhotoUploadRetry,
    useReminder,
    useRequestQueue,
    useSaveStoreToServer,
} from "@/hooks";
import { useAppSelector } from "@/hooks/redux";
import { Footer } from "@/shared/layout/Footer";

const FooterRender = () => {
    const location = useLocation();
    const segments = location.pathname.split("/");

    if (segments.length < 4) {
        return <Footer />;
    }

    return null;
};

const RequestQueueRunner = () => {
    useRequestQueue();
    return null;
};

const PhotoUploadRetryRunner = () => {
    usePhotoUploadRetry();
    return null;
};

const SaveStoreToServerRunner = () => {
    useSaveStoreToServer();
    return null;
};

const ReminderRunner = () => {
    useReminder();
    return null;
};

const MercureRunner = () => {
    useMercure();
    return null;
};

const OpenReplayRunner = () => {
    useOpenReplay();
    return null;
};

const PrivateLayoutContent = () => {
    useIndexedDBFocus();
    useConfigMercure();
    useLoadDictionaries();
    useLazyWarmups();

    return (
        <Layout>
            <AppInitializer />
            <UpdateBanner />
            <Outlet />
            <ModalsContainer />
            <FooterRender />

            {/* ----Runners----- */}
            <RequestQueueRunner />
            <PhotoUploadRetryRunner />
            <SaveStoreToServerRunner />
            <ReminderRunner />
            <MercureRunner />
            <OpenReplayRunner />
        </Layout>
    );
};

export const PrivateLayout = () => {
    const { isAuthenticated } = useAppSelector((state) => state.auth);

    if (!isAuthenticated) {
        return <Navigate replace to={ROUTES.Login} />;
    }

    return <PrivateLayoutContent />;
};
